import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import * as am5 from '@amcharts/amcharts5';
import * as am5plugins_exporting from '@amcharts/amcharts5/plugins/exporting';

export interface DataServiceResponse {
  data?: unknown;
  error?: { code: string; message: string; status: number };
}

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private atRiskStudentData = new Subject<DataServiceResponse>();
  private atRiskCommentData = new Subject<DataServiceResponse>();
  private data = new Subject<DataServiceResponse>();
  private dataPending = new Subject<boolean>();
  private transferStudentsFilterData = new Subject<any>();

  constructor() {}

  setData(data: DataServiceResponse) {
    this.data.next(data);
  }

  getData(): Observable<DataServiceResponse> {
    return this.data.asObservable();
  }

  setPendingData(pending: boolean) {
    this.dataPending.next(pending);
  }

  getPendingData() {
    return this.dataPending.asObservable();
  }

  // set data for at risk students
  setAtRiskStudentData(data: DataServiceResponse) {
    this.atRiskStudentData.next(data);
  }

  // get data for at risk students
  getAtRiskStudentData() {
    return this.atRiskStudentData.asObservable();
  }

  // set data for at risk students
  setAtRiskCommentData(data: DataServiceResponse) {
    this.atRiskCommentData.next(data);
  }

  // get data for at risk students
  getAtRiskCommentData() {
    return this.atRiskCommentData.asObservable();
  }

  getCurrentSemester(): number {
    return 202505;
  }

  round(value: number): number {
    return Math.round(value * 10000) / 100;
  }

  setTransferStudentsFilters(data: any) {
    this.transferStudentsFilterData.next(data);
  }

  getTransferStudentsFilters() {
    return this.transferStudentsFilterData.asObservable();
  }

  exportChartJsAsPNG(id: string, imageName: string) {
    const canvas = document.getElementById(id) as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Create a new temporary canvas
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height;
    const tempCtx = tempCanvas.getContext('2d');

    if (tempCtx) {
      // Fill background with white **before** drawing the chart
      tempCtx.fillStyle = 'white';
      tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

      // Copy the existing chart onto the new canvas
      tempCtx.drawImage(canvas, 0, 0);

      // Create download link
      const link = document.createElement('a');
      link.href = tempCanvas?.toDataURL('image/png'); // Convert canvas to PNG
      link.download = `${imageName}.png`; // File name
      link.click();
    }
  }

  exportAmChartsAsPNG(root: am5.Root, imageName: string) {
    const exporting = am5plugins_exporting.Exporting.new(root, {});
    exporting
      .export('png')
      .then((data) => {
        if (data) {
          const a = document.createElement('a');

          a.href = data;
          a.download = `${imageName}.png`; // File name
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
